import clsx from 'clsx';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { StudioBaseIconV2 } from 'shared/studio/StudioBaseIcon/StudioBaseIcon';
import { ArrowLeftIcon } from '@ag1/ui';
import { BaseImage } from 'types/studio/studio';
import { Step } from '../constants';
import type { BuildBundleMode } from '../types';
import styles from './HeaderBaB.module.scss';

interface Props {
  logo: BaseImage;
  title: string;
  subtitle: string;
  step: number;
  returnBack: () => void;
  mode: BuildBundleMode;
  isSecondProductIncluded: boolean;
}

export const HeaderBaB = ({
  step,
  returnBack,
  logo,
  title,
  subtitle,
  mode,
  isSecondProductIncluded
}: Props) => {
  const { t } = useTranslation('buildBundle');

  useEffect(() => {
    const handlePopState = () => {
      returnBack();
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [returnBack]);

  return (
    <div>
      <div className={styles.header}>
        {isSecondProductIncluded && (
          <button
            type="button"
            onClick={returnBack}
            className={clsx(styles.btnBack, {
              [styles.btnBackHidden]: mode === 'section' && step === Step.FIRST_STEP
            })}>
            <ArrowLeftIcon />
          </button>
        )}
        <h3 className={styles.title}>{title}</h3>
        <StudioBaseIconV2 icon={logo} className={styles.logo} />
      </div>
      {isSecondProductIncluded && (
        <div className={styles.progress}>
          <span className={styles.stepText}>{subtitle}</span>
          <span
            className={clsx(styles.step, {
              [styles.full]: step === Step.SECOND_STEP
            })}
          />
          <span className={styles.stepText}>{t('headerSteps', { step })}</span>
        </div>
      )}
    </div>
  );
};
